<template>

<div class="delete" :class="{'is-loading': is.loading}">

    <app-icon class="delete-loading" icon="loading" v-if="is.loading" />

    <template v-if="!is.loading">

        <app-icon icon="clash" class="delete-icon" />

        <div class="delete-title">Are you sure you wish to cancel?</div>

        <div class="delete-text">

            <p>Your membership will continue as normal until {{ subscription.date.renew | localDate('MM/DD/YYYY') }}.</p>

        </div>

        <div class="delete-buttons">

            <app-button theme="red" text="Confirm" :loading="is.confirming" v-on:click="onConfirmClick" />
            <app-button theme="grey" text="Nevermind" v-on:click="onCancelClick" />

        </div>

    </template>

</div>

</template>

<script>

export default {

	data: function() {

		return {
			is: {
				loading: true,
				confirming: false
			},
			subscription: {}
		}

	},

	created: function() {

		this.load();

	},

	methods: {

		onCancelClick: function() {

			this.$router.push({
				name: 'Membership.Subscription'
			})

		},

		onConfirmClick: async function() {

			this.is.confirming = true

			this.$api.delete('membership/subscription/cancel').then(function() {

				this.$router.push({
					name: 'Membership.Subscription'
				})

			}.bind(this))

		},

		load: function() {

			this.$api.get('membership/subscription/cancel').then(function(response) {

				this.subscription = response.subscription

				this.is.loading = false

			}.bind(this))

		}

	}

}

</script>

<style scoped>

.delete {
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #c55b5b;
}

.delete.is-loading {
	pointer-events: none;
}

.delete-loading {
    position: absolute;
	left: 50%;
	top: 50%;
	transform: translate(-50%, -50%);
	font-size: 48px;
	color: #ffbe7a;
}

.delete-icon {
	font-size: 96px;
}

.delete-title {
	font-size: 24px;
	font-weight: 400;
	padding: 20px 0px;
}

.delete-text {
	font-size: 16px;
	line-height: 20px;
	padding: 0px 100px;
	text-align: center;
	color: #333;
	font-weight: 300;
}

.delete-buttons {
	margin-top: 20px;
	display: flex;
	justify-content: center;
}

.delete-buttons >>> .button {
	margin: 0px 5px;
}

.delete-reason {
	margin-top: 20px;
}

</style>
